import styled from '@emotion/styled';
import * as Collapsible from '@radix-ui/react-collapsible';

import { animateCollapsibleContent } from '~/client/style/mixins';

export const ShowDetailsRoot = styled(Collapsible.Root)`
  display: contents;
`;

export const ShowDetailsTrigger = styled(Collapsible.Trigger)`
  cursor: pointer;
  background: transparent;
  border: none;
  ${({ theme }) => theme.text.h5}

  svg {
    width: 12px;
    height: 12px;
    margin-inline-start: ${({ theme }) => theme.spacing(2)};
    transition: ${({ theme }) => theme.transitions.create('transform')};
  }

  &[data-state='open'] {
    svg {
      transform: rotate(180deg);
    }
  }
`;

export const ShowDetailsContent = styled(Collapsible.Content)`
  ${animateCollapsibleContent}
`;
